import { ProductDTO } from '@/api/dto/ProductDTO';
import { ITableHeader } from '@/models/filters/Filters';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { CrudModule, IModuleState } from '@/store/entityModules/CrudModule';
import { Product } from '@/models/entities/Product';
import { ActionTree, GetterTree } from 'vuex';
import { EntityType } from '@/store/entityModules/types';

class ProductModule extends CrudModule<Product, ProductDTO> {
  state: IModuleState<Product, ProductDTO> = {
    ...this.state,

    entityType: EntityType.PRODUCT,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<IModuleState<Product, ProductDTO>, any> = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: Product) => i.id === id);
      return item || null;
    },

    getSearchValue(state): string | null {
      const filter = state.queryFilters as SearchQueryFilters;
      if (!filter.searchFilter) return null;
      return filter.searchFilter.value || null;
    },

    getSearchHeaders(state): ITableHeader[] {
      const filter = state.queryFilters as SearchQueryFilters;
      if (!filter.searchFilter) return [];
      return filter.searchFilter.headers;
    },
  };

  actions: ActionTree<IModuleState<Product, ProductDTO>, any> = {
    ...this.actions,

    setSearchValue({ getters, commit }, value: string | null) {
      commit('setQueryFilters', {
        searchFilter: {
          value,
          headers: getters['getSearchHeaders'],
        },
        // show results from the 1st page
        page: 1,
      });
    },

    setSearchHeaders({ commit, getters }, value: ITableHeader[]) {
      commit('setQueryFilters', {
        searchFilter: {
          headers: value,
        },
      });
    },
  };
}

const productsModule = new ProductModule();
export default productsModule;
